// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ----- GLOBAL STYLES ----- */
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* ----- TOPBAR ----- */
.topbar {
  background-color: #f7a141;
  color: #114370;
}

.topbar .navbar-brand {
  color: #fff;
}

.topbar .nav-link {
  color: #114370 !important;
  font-size: 20px;
  font-weight: 500;
}

/* ----- BUTTONS ----- */
button {
  background-color: #f7a141 !important;
  color: white !important;
}

.btn {
  background-color: #195557 !important;
}

.danger {
  background-color: red !important;
}

/* ----- SIDEBAR ----- */
.sidebar {
  background-color: #195557;
  border-right: 1px solid #ced4da;
  height: 100vh !important;
}

.nav-link {
  color: white !important;
}

.active {
  background-color: rgba(13, 110, 253, 0.25);
}

/* ----- MAIN CONTENT ----- */
.main {
  min-height: 100vh !important;
}

/* ----- FOOTER ----- */
.footer {
  width: 100%;
  background-color: #343a40;
  color: white;
  padding: 1rem;
}

.footer a {
  color: #adb5bd;
  text-decoration: none;
}

.footer a:hover {
  color: #fff;
}

/* ----- INSTANCE NAMES & ICONS ----- */
.instance-name-container {
  max-width: 60%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.instance-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 8px;
}

.instance-icons {
  max-width: 40%;
}

.instance-icons a,
.instance-icons .form-check {
  margin-left: 8px;
  display: flex;
  align-items: center;
}

.app-icon {
  color: #195557;
}

/* ----- SWITCHES ----- */
/* Remove float: left (was breaking thumb movement) */
.instance-switch .form-check .form-check-input {
  float: none !important;
}

/* Base switch input */
.form-check-input {
  border-color: grey;
  transition: background-color 0.3s, border-color 0.3s, transform 0.3s;
}

/* OFF state = red track, thumb left */
.form-switch .form-check-input:not(:checked) {
  background-color: #ff0000ab !important;
  border-color: #ff0000ab !important;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

/* ON state = green track, thumb right */
.form-switch .form-check-input:checked {
  background-color: #195557 !important;
  border-color: #195557 !important;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

/* ----- INSTANCE SWITCH LABELS ----- */
.instance-switch .form-check {
  display: inline-flex;
  align-items: center;
}

/* ----- FORM CHECK LABELS ----- */
.form-check-label {
  margin-left: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE;aACW;AACb;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,6BAA6B;AAC7B;EACE,4BAA4B;AAC9B;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA,uCAAuC;AACvC;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB,qDAAqD;AACrD;EACE,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA,sCAAsC;AACtC;EACE,sCAAsC;EACtC,kCAAkC;EAClC,4DAAwJ;AAC1J;;AAEA,wCAAwC;AACxC;EACE,oCAAoC;EACpC,gCAAgC;EAChC,4DAAwJ;AAC1J;;AAEA,uCAAuC;AACvC;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;AAClB","sourcesContent":["/* ----- GLOBAL STYLES ----- */\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  height: 100%;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* ----- TOPBAR ----- */\n.topbar {\n  background-color: #f7a141;\n  color: #114370;\n}\n\n.topbar .navbar-brand {\n  color: #fff;\n}\n\n.topbar .nav-link {\n  color: #114370 !important;\n  font-size: 20px;\n  font-weight: 500;\n}\n\n/* ----- BUTTONS ----- */\nbutton {\n  background-color: #f7a141 !important;\n  color: white !important;\n}\n\n.btn {\n  background-color: #195557 !important;\n}\n\n.danger {\n  background-color: red !important;\n}\n\n/* ----- SIDEBAR ----- */\n.sidebar {\n  background-color: #195557;\n  border-right: 1px solid #ced4da;\n  height: 100vh !important;\n}\n\n.nav-link {\n  color: white !important;\n}\n\n.active {\n  background-color: rgba(13, 110, 253, 0.25);\n}\n\n/* ----- MAIN CONTENT ----- */\n.main {\n  min-height: 100vh !important;\n}\n\n/* ----- FOOTER ----- */\n.footer {\n  width: 100%;\n  background-color: #343a40;\n  color: white;\n  padding: 1rem;\n}\n\n.footer a {\n  color: #adb5bd;\n  text-decoration: none;\n}\n\n.footer a:hover {\n  color: #fff;\n}\n\n/* ----- INSTANCE NAMES & ICONS ----- */\n.instance-name-container {\n  max-width: 60%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.instance-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin-right: 8px;\n}\n\n.instance-icons {\n  max-width: 40%;\n}\n\n.instance-icons a,\n.instance-icons .form-check {\n  margin-left: 8px;\n  display: flex;\n  align-items: center;\n}\n\n.app-icon {\n  color: #195557;\n}\n\n/* ----- SWITCHES ----- */\n/* Remove float: left (was breaking thumb movement) */\n.instance-switch .form-check .form-check-input {\n  float: none !important;\n}\n\n/* Base switch input */\n.form-check-input {\n  border-color: grey;\n  transition: background-color 0.3s, border-color 0.3s, transform 0.3s;\n}\n\n/* OFF state = red track, thumb left */\n.form-switch .form-check-input:not(:checked) {\n  background-color: #ff0000ab !important;\n  border-color: #ff0000ab !important;\n  --bs-form-switch-bg: url(data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e);\n}\n\n/* ON state = green track, thumb right */\n.form-switch .form-check-input:checked {\n  background-color: #195557 !important;\n  border-color: #195557 !important;\n  --bs-form-switch-bg: url(data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e);\n}\n\n/* ----- INSTANCE SWITCH LABELS ----- */\n.instance-switch .form-check {\n  display: inline-flex;\n  align-items: center;\n}\n\n/* ----- FORM CHECK LABELS ----- */\n.form-check-label {\n  margin-left: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
